import React, { useState, useEffect } from 'react';
import './CohortCountdown.css';

const CohortCountdown = () => {
  // Définir le nombre de places total et disponibles
  const totalSpots = 20;
  const eligibleSpots = 8;
  
  const [timeLeft, setTimeLeft] = useState({
    days: 12,
    hours: 23,
    minutes: 14,
    seconds: 4
  });

  useEffect(() => {
    // Date cible: 9 avril 2025
    const targetDate = new Date('April 9, 2025').getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      }
    };

    // Mettre à jour le compteur toutes les secondes
    const timer = setInterval(updateCountdown, 1000);
    updateCountdown(); // Mise à jour initiale

    // Nettoyer le timer
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="cohort-countdown" id="cohort">
      <div className="countdown-container">
        <h2 className="countdown-title">REJOINDRE LA PROCHAINE COHORTE PROSPERIAN</h2>
        
        <div className="countdown-timer">
          <div className="countdown-item" data-aos="fade-up" data-aos-delay="100">
            <div className="countdown-value">{timeLeft.days}</div>
            <div className="countdown-label">Jours</div>
          </div>
          
          <div className="countdown-item" data-aos="fade-up" data-aos-delay="150">
            <div className="countdown-value">{timeLeft.hours}</div>
            <div className="countdown-label">Heures</div>
          </div>
          
          <div className="countdown-item" data-aos="fade-up" data-aos-delay="200">
            <div className="countdown-value">{timeLeft.minutes}</div>
            <div className="countdown-label">Minutes</div>
          </div>
          
          <div className="countdown-item" data-aos="fade-up" data-aos-delay="250">
            <div className="countdown-value">{timeLeft.seconds}</div>
            <div className="countdown-label">Secondes</div>
          </div>
        </div>
        
        <p className="countdown-info" data-aos="fade-up" data-aos-delay="300">
          Notre programme d'accélération démarre le 9 avril 2025.
        </p>
        
        <div className="cta-text">
          <h3>Démarrez maintenant pour intégrer la prochaine cohorte</h3>
          <p>Seulement {eligibleSpots} des {totalSpots} places sont encore disponibles pour avril 2024</p>
        </div>
        <div className="cta-buttons">
          <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
            <button className="cta-button primary">RÉSERVER MON ÉVALUATION GRATUITE</button>
          </a>
          <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
            <button className="cta-button secondary">DÉCOUVRIR LE PROGRAMME</button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CohortCountdown; 